import { TextSegmentConfig, TextSegments } from 'ui/workflows/flowchart';
import { CallWebhookNodeData, SendToWorkflowNodeData } from '../../types';

const hasWebhookId = (workflowWebhookId?: number): boolean => typeof workflowWebhookId === 'number';
const getWebhookTextSegmentConfig = ({
  endpoint,
  workflowWebhookId,
  resource,
}: CallWebhookNodeData): TextSegmentConfig => {
  const hasPreconfiguredWebhook = hasWebhookId(workflowWebhookId);
  const text = hasPreconfiguredWebhook ? resource?.name || '' : endpoint;

  return {
    isTruncated: true,
    showTooltipIfTruncated: true,
    // Only the urls should be underlined
    segments: [{ text: text || '', isUnderlined: !hasPreconfiguredWebhook, isDashed: true }],
  };
};

const webhook = {
  isSetup: ({ endpoint, workflowWebhookId }: CallWebhookNodeData): boolean =>
    !!endpoint || hasWebhookId(workflowWebhookId),
  getTextSegments: (nodeData: CallWebhookNodeData): TextSegments => ({
    nodeDescBottom: getWebhookTextSegmentConfig(nodeData),
  }),
};

const workflow = {
  isSetup: ({ workflowId }: SendToWorkflowNodeData): boolean => !!workflowId,
  getTextSegments: ({ resource }: SendToWorkflowNodeData) => ({
    nodeDescBottom: {
      isTruncated: true,
      segments: [{ text: resource?.name || '' }],
    },
  }),
};

export default { webhook, workflow };
